import {
  Component,
  Input,
  TemplateRef,
  ViewChild,
  Output,
  EventEmitter,
  inject,
  ChangeDetectionStrategy
} from '@angular/core';
import { MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

@Component({
  selector: 'vshc-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: [ './dialog.component.scss' ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DialogComponent {

  #dialog = inject(MatDialog);

  dialog: MatDialogRef<any>;
  afterClosedSubscription: Subscription;
  afterOpenedSubscription: Subscription;
  onEscKeySubscription: Subscription;

  @Input()
  autoFocus = true;

  @Input()
  options: MatDialogConfig = {};

  @Input()
  backdropClass: string | string[];

  @Output()
  closeTrigger = new EventEmitter<void>();

  @Output()
  afterOpen = new EventEmitter<void>();

  @ViewChild('ref', { static: true })
  templateRef: TemplateRef<any>;

  @Input()
  set open(v: boolean) {
    if (v === true) {
      setTimeout(() => {
        this.dialog = this.#dialog.open(this.templateRef, {
          disableClose: true,
          autoFocus: this.autoFocus,
          backdropClass: this.backdropClass,
          restoreFocus: false,
          ...this.options,
        });

        this.afterClosedSubscription = this.dialog.afterClosed().subscribe(() => {
          this.closeTrigger.emit();
        });

        this.afterOpenedSubscription = this.dialog.afterOpened().subscribe(() => {
          this.afterOpen.emit();
        });

        this.onEscKeySubscription = this.dialog.keydownEvents().subscribe(event => {
          if (event.key === 'Escape') {
            if (this.dialog && (this.options?.disableClose === false || !this.options?.disableClose)) {
              this._closeDialog();
              this.closeTrigger.emit();
            }
          }
        });
      });
    } else if (this.dialog) {
      this._closeDialog();
    }
  }

  close() {
    this.dialog?.close();
  }

  private _closeDialog() {
    this.dialog.close();
    this.afterClosedSubscription.unsubscribe();
    this.afterOpenedSubscription.unsubscribe();
    this.onEscKeySubscription.unsubscribe();
  }

}
